/* eslint-disable react/prop-types */
'use client'

import { LoadingTemplate } from '@mercadoni/sinister/dist/cjs/shared/components'
import { Skeleton } from 'antd'
import styled from 'styled-components'

import {
  LayoutFilterProducts,
  ProductsContainer,
  ProductsHeaderStyles,
} from './LoadingFilterProductsStyles'

export const FiltersSkeletonStyled = styled.div`
  margin: var(--spacing-borderRadius-medium) var(--spacing-padding-xlarge);
  .skeleton-item {
    height: 50px;
    margin-top: var(--spacing-margin-xSmall);
  }
`

const FiltersSkeletons = () => (
  <FiltersSkeletonStyled>
    {Array(5)
      .fill()
      .map((_, position) => (
        <Skeleton.Input
          key={`skeleton-${position + 1}`}
          active
          block
          size="large"
          className="skeleton-item"
        />
      ))}
  </FiltersSkeletonStyled>
)

const MobileLayoutSkeleton = ({ hasBreadcrumbs }) => (
  <LayoutFilterProducts isMobile>
    {hasBreadcrumbs && (
      <div className="breadcrumbs-container">
        <Skeleton.Input active block size="large" className="skeleton-item" />
      </div>
    )}
    <ProductsHeaderStyles>
      <Skeleton.Input active block size="large" className="skeleton-item" />
    </ProductsHeaderStyles>
    <ProductsHeaderStyles>
      <Skeleton.Input active block size="large" className="skeleton-item" />
    </ProductsHeaderStyles>
    <div className="grid-content">
      <ProductsContainer isMobile>
        <LoadingTemplate headless isMobile />
      </ProductsContainer>
    </div>
  </LayoutFilterProducts>
)

const DesktopLayoutSkeleton = ({ hasBreadcrumbs }) => (
  <LayoutFilterProducts>
    {hasBreadcrumbs && (
      <div className="breadcrumbs-container">
        <Skeleton.Input active block size="large" className="skeleton-item" />
      </div>
    )}
    <div className="grid-content">
      <div>
        <FiltersSkeletons />
      </div>
      <div>
        <div className="banners-container">
          <Skeleton.Input
            active
            block
            size="large"
            style={{ height: '148px' }}
          />
        </div>
        <ProductsHeaderStyles>
          <Skeleton.Input active block size="large" className="skeleton-item" />
        </ProductsHeaderStyles>
        <Skeleton.Input active block size="large" className="skeleton-item" />
        <ProductsContainer>
          <LoadingTemplate headless />
        </ProductsContainer>
      </div>
    </div>
  </LayoutFilterProducts>
)

const LoadingFilterProducts = ({ isMobile, hasBreadcrumbs }) => {
  return isMobile ? (
    <MobileLayoutSkeleton hasBreadcrumbs={hasBreadcrumbs} isMobile />
  ) : (
    <DesktopLayoutSkeleton hasBreadcrumbs={hasBreadcrumbs} />
  )
}
export default LoadingFilterProducts
